import { ShieldCheck, Sparkles, MessageSquareHeart, Heart, PawPrint, Star, Home, BadgeCheck, Bell, MapPin } from "lucide-react";

export const INFO_ICONS = {
  shield: { icon: ShieldCheck, label: "Shield" },
  sparkles: { icon: Sparkles, label: "Sparkles" },
  message: { icon: MessageSquareHeart, label: "Message" },
  heart: { icon: Heart, label: "Heart" },
  paw: { icon: PawPrint, label: "Paw" },
  star: { icon: Star, label: "Star" },
  home: { icon: Home, label: "Home" },
  badge: { icon: BadgeCheck, label: "Badge" },
  bell: { icon: Bell, label: "Bell" },
  map: { icon: MapPin, label: "Map pin" },
};

export const INFO_GRID = {
  1: "max-w-xl",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-2 lg:grid-cols-4",
  5: "md:grid-cols-3 xl:grid-cols-5",
};
